<template>
  <div v-if="venueCampaign">
    <vs-prompt
      @accept="$emit('onSubmit', submitComment)"
      title="Submit Campaign?"
      accept-text="Submit campaign"
      :is-valid="!submitCommentTooLong"
      :active.sync="submitPopupActive"
    >
      <div>Are you sure you want to Submit the campaign for approval?</div>
      <br />

      Specify a comment to the reviewers:
      <vs-textarea
        placeholder="Write a comment (optional)..."
        v-model="submitComment"
        counter="250"
        :counter-danger.sync="submitCommentTooLong"
      />
    </vs-prompt>

    <vx-card no-shadow>
      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-2/5 w-full">
          <vs-row>
            <h2 class="mr-2">Campaign</h2>
            <vs-chip
              class="mt-1"
              :color="statusObject(venueCampaign.status).color"
            >
              <b>{{ statusObject(venueCampaign.status).text }}</b>
            </vs-chip>
          </vs-row>
        </div>
      </div>

      <h4>General info</h4>
      <p class="mb-2">
        This pane contains the general information of your campaign.
      </p>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Type</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-chip class="product-order-status">
            {{ typeToText(venueCampaign.isBasedOnMasterCampaign) }}
          </vs-chip>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Title</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <span style="font-size: 11px">
            This is the title of your campaign. Only used internally and not
            visible to recipients.</span
          >

          <vs-row v-if="!isGeneralEditable"
            ><b>{{ venueCampaign.title }}</b></vs-row
          >
          <vs-input
            v-else
            label=""
            v-model="venueCampaign.title"
            class="w-full"
          />
        </div>
      </div>

      <div class="vx-row mb-6" v-if="venueCampaign.isBasedOnMasterCampaign">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Fillout deadline</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <span style="font-size: 11px">Deadline to be approved at latest</span>
          <vs-row v-if="!isGeneralEditable">
            <feather-icon
              class="mr-1"
              :icon="'CalendarIcon'"
              svgClasses="text-grey w-5 h-5"
            />
            <b>{{
              moment(venueCampaign.approvedByDate).format("LL")
            }}</b></vs-row
          >
          <DatePicker
            v-else
            is24hr
            :attributes="calendarAttributes"
            is-expanded
            v-model="venueCampaign.approvedByDate"
          ></DatePicker>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="isGeneralEditable">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Campaign medium</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-checkbox v-model="venueCampaign.hasEmail" class="w-full mb-2"
            >Email</vs-checkbox
          >
          <vs-checkbox v-model="venueCampaign.hasSms" class="w-full mb-2"
            >Sms</vs-checkbox
          >
          <vs-checkbox v-model="venueCampaign.hasNpPush" class="w-full"
            >NightPay Push</vs-checkbox
          >
        </div>
      </div>

      <div class="vx-row mb-6" v-if="venueCampaign.isBasedOnMasterCampaign">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Purpose of campaign</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <p class="whitespace-pre-wrap">
            <span>{{ venueCampaign.activatedComment }}</span>
          </p>
        </div>
      </div>

      <!-- <h4 class="mt-8 mb-4">Campaign audience</h4> -->

      <!-- <div class="vx-row mb-6" v-if="isGeneralEditable">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Has Email</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-checkbox v-model="venueCampaign.hasEmail" class="w-full" />
        </div>
      </div> -->

      <!-- <div class="vx-row mb-6" v-if="isGeneralEditable">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Has Sms</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-checkbox v-model="venueCampaign.hasSms" class="w-full" />
        </div>
      </div> -->

      <h4 class="mt-8 pt-6">Campaign audience</h4>
      <p class="max-w-lg mb-4">
        Remember to select your audience carefully. You can target a separate
        audience for each medium and can use conditions to target audience by
        age, interests and labels.
      </p>

      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/5 w-full">
          <!-- <span>Campaign audience</span> -->
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <guest-query-builder
            v-if="venueCampaign.hasEmail"
            title="Email Audience"
            @validQuery="(e) => (emailQueryValid = e)"
            :guestQuery.sync="venueCampaign.emailGuestQuery"
            :deactivateVenueSelect="true"
            :dontShowConsentsRow="true"
            :deactivateAll="!isGeneralEditable"
          />
          <guest-query-builder
            class="mt-4"
            v-if="venueCampaign.hasSms"
            title="Sms Audience"
            @validQuery="(e) => (smsQueryValid = e)"
            :guestQuery.sync="venueCampaign.smsGuestQuery"
            :deactivateVenueSelect="true"
            :dontShowConsentsRow="true"
            :deactivateAll="!isGeneralEditable"
          />
          <guest-query-builder
            class="mt-4"
            v-if="venueCampaign.hasNpPush"
            title="Nightpay Push Notification Audience"
            @validQuery="(e) => (npPushQueryValid = e)"
            :guestQuery.sync="venueCampaign.npPushGuestQuery"
            :deactivateVenueSelect="true"
            :dontShowConsentsRow="true"
            :deactivateAll="!isGeneralEditable"
          />
        </div>
      </div>

      <h4 class="mt-8 pt-6">Send dates</h4>
      <p class="max-w-lg mb-4">
        This is the date and time on which your campaigns, if approved by HQ
        Marketing, will be sent out. You can use separate date and times for
        each medium you've chosen.
      </p>

      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/5 w-full">
          <!-- <span>Send dates</span> -->
        </div>
        <div class="vx-col sm:w-2/5 max-w-sm" v-if="venueCampaign.hasEmail">
          <span style="font-size: 11px"
            ><b>Email</b> scheduled to be sent, if approved, at</span
          >
          <vs-row v-if="!isGeneralEditable">
            <feather-icon
              class="mr-1"
              :icon="'CalendarIcon'"
              svgClasses="text-grey w-5 h-5"
            />
            <b>{{ venueCampaign.sendEmailDate | formatDate }}</b></vs-row
          >
          <DatePicker
            v-else
            is24hr
            :min-date="new Date()"
            mode="dateTime"
            :attributes="calendarAttributes"
            is-expanded
            v-model="venueCampaign.sendEmailDate"
          />
        </div>
        <div class="vx-col sm:w-2/5 max-w-sm" v-if="venueCampaign.hasSms">
          <span style="font-size: 11px"
            ><b>Sms</b> scheduled to be sent, if approved, at</span
          >
          <vs-row v-if="!isGeneralEditable">
            <feather-icon
              class="mr-1"
              :icon="'CalendarIcon'"
              svgClasses="text-grey w-5 h-5"
            />
            <b>{{ venueCampaign.sendSmsDate | formatDate }}</b></vs-row
          >
          <DatePicker
            v-else
            mode="dateTime"
            :min-date="new Date()"
            is24hr
            :attributes="calendarAttributes"
            is-expanded
            v-model="venueCampaign.sendSmsDate"
          />
        </div>
        <div class="vx-col sm:w-2/5 max-w-sm" v-if="venueCampaign.hasNpPush">
          <span style="font-size: 11px"
            ><b>NightPay Push</b> scheduled to be sent, if approved, at</span
          >
          <vs-row v-if="!isGeneralEditable">
            <feather-icon
              class="mr-1"
              :icon="'CalendarIcon'"
              svgClasses="text-grey w-5 h-5"
            />
            <b>{{ venueCampaign.sendNpPushDate | formatDate }}</b></vs-row
          >
          <DatePicker
            v-else
            mode="dateTime"
            :min-date="new Date()"
            is24hr
            :attributes="calendarAttributes"
            is-expanded
            v-model="venueCampaign.sendNpPushDate"
          />
        </div>
      </div>

      <!-- Save Button -->
      <vs-row
        vs-justify="flex-end"
        class="flex flex-wrap items-center"
        style="margin-top: 32px"
      >
        <vs-button
          color="primary"
          id="reset-button"
          @click="$emit('onPreview')"
          class="mr-2 mt-2"
          >Preview campaign</vs-button
        >
        <vs-button
          v-if="isEditable && isGeneralEditable"
          id="save-button"
          @click="$emit('onSave')"
          class="mt-2"
          >Save Changes</vs-button
        >
      </vs-row>

      <vs-divider class="mb-8" />

      <vs-row
        class="my-4 max-w-lg"
        v-if="
          venueCampaign.status === 'SubmittedForApproval' &&
          hasPermissionForActiveVenue('vp.vp.venuecampaigns.edit')
        "
      >
        <span
          >The campaign cannot be edited while it is submitted for approval.
          Click the button below to retract the submission and make the campaign
          editable again.</span
        >
        <vs-button
          color="danger"
          id="reset-button"
          @click="$emit('onRetractSubmission')"
          class="mt-2"
          >Retract submission</vs-button
        >
      </vs-row>

      <div class="max-w-lg mx-auto">
        <venue-campaign-action-log :venueCampaign="venueCampaign" />
      </div>

      <vs-row vs-justify="center" class="mt-6">
        <vs-button
          v-if="
            isEditable &&
            hasPermissionForActiveVenue('vp.vp.venuecampaigns.edit')
          "
          :disabled="!canSubmit"
          id="submit-button"
          @click="
            $emit('onSave');
            submitPopupActive = true;
          "
          class="my-2 py-6"
          >{{ venueCampaign.status == "Rejected" ? "Res" : "S" }}ubmit for
          approval</vs-button
        >
        <vs-button
          v-if="
            isEditable &&
            venueCampaign.isBasedOnMasterCampaign &&
            hasPermissionForActiveVenue('vp.vp.venuecampaigns.edit')
          "
          color="danger"
          id="reset-button"
          @click="$emit('onReset')"
          class="my-2 py-6 ml-2"
          >Reset entire campaign</vs-button
        >
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import { DatePicker } from "v-calendar";
import moment from "moment";
import campaignMixin from "@/views/mixins/campaignMixin";
import VenueCampaignActionLog from "./VenueCampaignActionLog.vue";

import GuestQueryBuilder from "@/components/GuestQueryBuilder.vue";

export default {
  props: ["venueCampaign", "isEditable"],
  mixins: [campaignMixin],
  components: {
    DatePicker,
    VenueCampaignActionLog,
    GuestQueryBuilder,
  },
  data() {
    return {
      moment,
      submitComment: "",
      submitCommentTooLong: false,
      submitPopupActive: false,

      emailQueryValid: false,
      smsQueryValid: false,
      npPushQueryValid: false,

      calendarAttributes: [
        {
          key: "today",
          highlight: "gray",
        },
      ],
    };
  },
  methods: {
    logItemColor(item) {
      return this.statusObject(item.status).color;
    },
    typeToText(type) {
      if (type == null) return "Created By HQ";
      return type ? "Created by HQ" : "Created by Venue";
    },
  },
  computed: {
    canSubmit() {
      if (!this.isEditable) return false;
      if (
        !this.venueCampaign.hasEmail &&
        !this.venueCampaign.hasSms &&
        !this.venueCampaign.hasNpPush
      )
        return false;

      if (
        this.venueCampaign.hasEmail &&
        (!this.venueCampaign.emailJson || this.venueCampaign.emailJson == "")
      )
        return false;

      if (this.venueCampaign.hasSms && this.venueCampaign.smsContent == "")
        return false;

      if (
        this.venueCampaign.hasNpPush &&
        (!this.venueCampaign.npPushInfo ||
          this.venueCampaign.npPushInfo.title == "" ||
          this.venueCampaign.npPushInfo.body == "")
      )
        return false;

      if (
        this.venueCampaign.hasEmail &&
        this.venueCampaign.sendEmailDate == null
      )
        return false;

      if (this.venueCampaign.hasSms && this.venueCampaign.sendSmsDate == null)
        return false;

      if (
        this.venueCampaign.hasNpPush &&
        this.venueCampaign.sendNpPushDate == null
      )
        return false;

      if (this.venueCampaign.hasSms && !this.smsQueryValid) return false;
      if (this.venueCampaign.hasEmail && !this.emailQueryValid) return false;
      if (this.venueCampaign.hasNpPush && !this.npPushQueryValid) return false;

      return true;
    },
    isGeneralEditable() {
      return !this.venueCampaign.isBasedOnMasterCampaign && this.isEditable;
    },
  },
};
</script>

<style lang="scss">
.con-vs-dialog .vs-dialog {
  max-width: 800px !important;
  position: relative;
}

.bg-green {
  background-color: #4dbd74 !important;
}
</style>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>